var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rule-name-cell"},[_c('div',{ref:"name",staticClass:"rule-name-cell__name",attrs:{"title":_vm.initialReduce ? '' : _vm.name}},[_vm._v(" "+_vm._s(_vm.ruleName)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }